import { render, staticRenderFns } from "./GridPoints.vue?vue&type=template&id=9c463fb0&scoped=true&"
import script from "./GridPoints.vue?vue&type=script&lang=js&"
export * from "./GridPoints.vue?vue&type=script&lang=js&"
import style0 from "./GridPoints.vue?vue&type=style&index=0&id=9c463fb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c463fb0",
  null
  
)

export default component.exports